import { DayOption, ScheduleDay, ScheduleType } from "./types";

export const DAYS = [
  { val: 1, label: "Monday", short: "Mon" },
  { val: 2, label: "Tuesday", short: "Tue" },
  { val: 3, label: "Wednesday", short: "Wed" },
  { val: 4, label: "Thursday", short: "Thu" },
  { val: 5, label: "Friday", short: "Fri" },
  { val: 6, label: "Saturday", short: "Sat" },
  { val: 7, label: "Sunday", short: "Sun" },
];

export const DAY_LABEL = new Map(DAYS.map((d) => [d.val, d.label]));

export const WEEK_OPTIONS: DayOption[] = DAYS.map((d) => ({
  value: d.val,
  label: d.short,
}));

export const MONTH_OPTIONS: DayOption[] = Array.from(
  { length: 31 },
  (_, i) => ({
    value: i + 1,
    label: String(i + 1),
  })
);

export const MODE_OPTIONS: { label: string; value: ScheduleType }[] = [
  { label: "Days of week", value: "week" },
  { label: "Calendar days", value: "month" },
];

export const EMPTY_DAYS: ScheduleDay[] = [];
export const EMPTY_SAVED_DAYS: Record<ScheduleType, ScheduleDay[]> = {
  week: EMPTY_DAYS,
  month: EMPTY_DAYS,
};

export const DEFAULT_FROM = "00:00";
export const DEFAULT_TO = "24:00";

export const MIN_GROUP_LENGTH = 3;

export const TIME_RE = /^(([01]\d|2[0-3]):[0-5]\d|24:00)$/;

export const TIME_ERRORS = {
  from: "Start time must be in range 00:00–23:59",
  to: "End time must be in range 00:00–24:00",
  bothOrNone: "Enter start and end time or leave both empty",
  range: "Start time must be earlier than end time",
};
